<ng-container *ngIf="rate">
   <bar-rating [(rate)]="rate" max="5" readOnly=true></bar-rating>
</ng-container>
